import(/* webpackMode: "eager", webpackExports: ["ResendView"] */ "/app/src/features/auth/components/resend/resend-view.tsx");
